import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Selection from 'common/components/Form/Selection';
import classNames from 'classnames';

class Languages extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    checked: PropTypes.array.isRequired,
    page: PropTypes.number,
    form: PropTypes.object,
    title: PropTypes.string,
    onAddCategory: PropTypes.func,
  };

  static defaultProps = {
    form: null,
    title: null,
    onAddCategory: null,
  };

  constructor(props) {
    super(props);

    this.onCheckAll = ::this.onCheckAll;
    this.onUncheckMain = ::this.onUncheckMain;
  }

  onCheckAll(parent_id) {
    let checkboxChecked = true;
    let valuesArray = [];

    if (!document.querySelector(`.session-filter-dialog__language-parent-checkbox--${parent_id} input`).checked) {
      checkboxChecked = false;
    }

    Array.from(document.querySelectorAll(`.session-filter-dialog__language-checkbox input`)).map((checkbox) => {
      if(checkbox.checked) {
        valuesArray.push(checkbox.value);
      }
    });

    this.props.onAddCategory && this.props.onAddCategory(valuesArray);
  }

  onUncheckMain(parent_id) {
    let valuesArray = [];
    let childrenArray = [];
    const parentCheckbox = document.querySelector(`.session-filter-dialog__language-parent-checkbox--${parent_id} input`);
    const childrenCheckbox = document.querySelectorAll(`.session-filter-dialog__language-child-checkbox--${parent_id} input`);

    parentCheckbox.checked = false;

    Array.from(childrenCheckbox).map((checkbox) => {
      if(checkbox.checked) {
        childrenArray.push(checkbox.value);
      }
    });

    if (childrenArray.length === childrenCheckbox.length) {
      parentCheckbox.checked = true;
    }

    Array.from(document.querySelectorAll(`.session-filter-dialog__language-checkbox input`)).map((checkbox) => {
      if(checkbox.checked) {
        valuesArray.push(checkbox.value);
      }
    });

    this.props.onAddCategory && this.props.onAddCategory(valuesArray);
  }

  render() {
    const { list, title, checked, page } = this.props;

    return (
      <div>
        {title && (<div className="session-filter-dialog__section-title">{ title }</div>)}
        <div
          className={classNames(
            'session-filter-dialog__section-body',
            'session-filter-dialog__languages',
          )}
        >
          {list.map(element => (<div className="session-filter-dialog__language" key={element.name + element.id +  page}>
            <Field
              type="checkbox"
              name="languages"
              value={element.id}
            >
              { ({ input }) => (
                <Selection
                  type="checkbox"
                  id={`languages__${element.id}`}
                  label={element.name}
                  className={`session-filter-dialog__language-checkbox session-filter-dialog__language-parent-checkbox session-filter-dialog__language-parent-checkbox--${element.id}`}
                  defaultChecked={checked.indexOf(element.id) >= 0}
                  onClick={() => {this.onCheckAll(element.id)}}
                  {...input}
                />
              ) }
            </Field>
          </div>)
        )}
        </div>
      </div>
    );
  }
}

export default Languages;
